import React from "react";
import { Paper } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { BuscadorTextField } from "./BuscadorTextField";
import { TabsSeccion } from './TabsSeccion';

export const Buscador = () => {
    const params: any = useParams();
    
    return <div style={{ padding: "20px" }}>
        <Paper style={{ padding: "20px" }} elevation={0} square>
            <BuscadorTextField style={{ width: "100%" }} valor={params.valor}></BuscadorTextField>
        </Paper>
        <TabsSeccion texto={params.valor} />
    </div>
}